import { CommonModule } from '@angular/common';
import { Location, LocationStrategy } from '@angular/common';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener,
  Renderer2,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  RouterLink,
} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuthService } from '../../pages/shared/auth.service';
import { MakerService } from '../../pages/shared/maker.service';
import { TakerService } from '../../pages/shared/taker.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LocationService } from 'src/app/shared/locations/location.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    // BrowserAnimationsModule,
    TranslateModule,
    NgSelectModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    LoginComponent,
    IconsModule,
    BsDropdownModule,
  ],
  styleUrls: ['./navbar.component.scss'],
  templateUrl: './navbar.component.html',
  animations: [
    trigger('openClose', [
      // ...
      state(
        'open',
        style({
          width: '80%',
        })
      ),
      state(
        'closed',
        style({
          width: '0px',
        })
      ),
      transition('open => closed', [animate('0.25s')]),
      transition('closed => open', [animate('0.25s')]),
    ]),
  ],
})
export class NavbarComponent implements OnInit {
  @ViewChild('loginModalContent') loginModalContent: TemplateRef<any>;
  isAdmin = false;
  modalRef: BsModalRef;
  public iconOnlyToggled = false;
  public activeLang = 'es';
  loginData: any = {};
  isOpen = false;

  isCms = false;
  cmsValidated: any;

  experienceSearchForm: FormGroup;
  experiencesCities: any[] = []; // Array to hold the list of locations
  citySelected: string; // Selected city ID

  constructor(
    public authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    public makerService: MakerService,
    public takerService: TakerService,
    private modalService: BsModalService,
    public translate: TranslateService,
    private formBuilder: FormBuilder,
    private locationService: LocationService,
    private renderer: Renderer2
  ) {
    router.events.subscribe((val) => {
      if (
        location.path().indexOf('/' + this.activeLang + '/maker/admin/') ===
          0 ||
        location.path().indexOf('/' + this.activeLang + '/taker/admin/') ===
          0 ||
        location.path().indexOf('/' + this.activeLang + '/reseller/admin/') ===
          0
      ) {
        this.isAdmin = true;
      }
    });
  }

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   const navbar = document.querySelector('.navbar') as HTMLElement | null;
  //   const openCloseContainer = document.querySelector('.open-close-container') as HTMLElement | null;

  //   if (navbar && openCloseContainer) {
  //     if (window.scrollY >= navbar.offsetTop) {
  //       this.renderer.setStyle(openCloseContainer, 'position', 'fixed');
  //       this.renderer.setStyle(openCloseContainer, 'top', '0');
  //     } else {
  //       this.renderer.setStyle(openCloseContainer, 'position', 'absolute');
  //       this.renderer.setStyle(openCloseContainer, 'top', '0');
  //     }
  //   }
  // }

  ngOnInit(): void {
    this.experienceSearchForm = this.formBuilder.group({
      location: ['', Validators.required],
    });

    this.loadexperiencesCities();
    console.log(
      'Initialization complete. Current destinations:',
      this.experiencesCities
    );

    if (!this.cmsValidated) {
      this.getIsCms();
    }
    /* if (!this.isCms) {
      this.getNavigatorLang();
    } */

    // this.adjustSiblingMargin();
    setTimeout(() => {
      this.loginData.email =
        this.activatedRoute.snapshot.queryParamMap.get('email');
      this.loginData.password =
        this.activatedRoute.snapshot.queryParamMap.get('pk');

      if (this.activatedRoute.snapshot.queryParamMap.get('login') == 'true') {
        this.openLoginModal(this.loginModalContent);
      }
    }, 500);
  }

  getNavigatorLang() {
    const lang = (navigator.language || navigator['userLanguage']).split(
      '-'
    )[0];
    // console.log("idioma real navegador: ", lang);

    if (lang === 'es' || lang === 'en') {
      this.translate.currentLang = lang;
      this.translate.setDefaultLang(lang);
    } else {
      this.translate.currentLang = 'en';
      this.translate.setDefaultLang('en');
    }

    console.log('Idioma del navegador aplicado:', this.translate.currentLang);
  }

  getIsCms() {
    if (this.location.path().indexOf('admin') !== -1) {
      this.translate.currentLang = 'es';
      this.translate.setDefaultLang('es');
      this.isCms = true;
    } else {
      this.activeLang = this.location.path().substring(1, 3);
      // console.log("ACTIVE LANG...: ", this.activeLang);
      this.translate.currentLang =
        this.activeLang ?? this.translate.getDefaultLang();
      // this.translate.setDefaultLang(this.activeLang === 'ev' ? 'es' : this.activeLang);
      this.translate.setDefaultLang(
        this.activeLang ? this.activeLang : this.translate.getDefaultLang()
      );
      // this.translate.currentLang = this.translate.getDefaultLang();

      this.isCms = false;
    }

    // return this.cmsValidated = true;

    return this.isCms;
  }

  logout() {
    this.isAdmin = false;
    this.authService.logout();
    // this.router.navigateByUrl('/' + this.translate.getDefaultLang());
    location.replace('/' + this.translate.getDefaultLang());
  }

  // login() {
  //   this.router.navigateByUrl('/login');
  // }

  openLoginModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  // toggle sidebar
  toggleSidebar() {
    let body = this.renderer.selectRootElement('body', true);
    this.iconOnlyToggled = !this.iconOnlyToggled;
    if (this.iconOnlyToggled) {
      body.classList.add('sidebar-icon-only');
    } else {
      body.classList.remove('sidebar-icon-only');
    }
  }

  search(isNavbarSearch: boolean, type: string): void {
    const locationValue = this.experienceSearchForm.get('location')?.value;

    // Fallback behavior if no location is selected
    const fallbackValue = 'españa'; // Default location if no value is selected
    // Find the selected city by ID and get its slug or name for URL
    const selectedCity = this.experiencesCities.find(
      (city) => city.name === locationValue
    );
    // Construct the citySlug dynamically
    const citySlug = selectedCity
      ? selectedCity.name.toLowerCase()
      : fallbackValue;

    // Log errors if the location is not found or data is not initialized
    if (!selectedCity && locationValue) {
      console.warn(
        'Selected location not found in the available cities:',
        locationValue
      );
    } else if (!this.experiencesCities || this.experiencesCities.length === 0) {
      console.error('No destinations are initialized. Check data source.');
    }

    // Navigate to the destination
    const searchUrl = `/${this.translate.getDefaultLang()}/destino/${citySlug}`;
    location.href = searchUrl;
  }

  loadexperiencesCities(): void {
    this.locationService.getActiveLocations().subscribe((locations) => {
      this.experiencesCities = locations['hydra:member'];
      if (this.activatedRoute.snapshot.queryParams['localidad']) {
        this.experienceSearchForm
          .get('location')
          .setValue(
            parseInt(this.activatedRoute.snapshot.queryParams['localidad'])
          );
      }
    });
    /* this.locationService.getMakerActiveLocations().subscribe(
      (locations: any) => {
        const cities = locations['hydra:member'];
        if (Array.isArray(cities) && cities.length > 0) {
          this.experiencesCities = cities;
        } else {
          console.warn('No active locations found in the response.');
          this.experiencesCities = [];
        }
      },
      (error) => {
        console.error('Failed to load locations:', error);
        this.experiencesCities = []; // Clear data on error
      }
    ); */
  }

  public changeLanguage(event) {
    this.activeLang = event.target.value.toLowerCase();
    this.translate.use(event.target.value.toLowerCase());
    window.open(
      `/${event.target.value.toLowerCase()}${this.router.url.substring(3)}`,
      '_self'
    );
  }

  changeMobileLanguage(event) {
    this.activeLang = event.target.textContent.toLowerCase();
    this.translate.use(event.target.textContent.toLowerCase());
    window.open(
      `/${event.target.textContent.toLowerCase()}${this.router.url.substring(
        3
      )}`,
      '_self'
    );
  }

  getFirstWord(phrase: string): string {
    // Split the phrase into words using spaces as a delimiter
    const words = phrase ? phrase.split(' ') : '';

    // Check if there are words in the phrase
    if (words.length > 0) {
      if (words[0].length < 11) {
        // Return the first word
        return words[0] + '...';
      } else {
        return words[0].slice(0, 10) + '...';
      }
    } else {
      // If there are no words, return an empty string or handle the case accordingly
      return this.makerService.getUserMail();
    }
  }

  //Burguer menu
  openBurguerMenu() {
    this.isOpen = !this.isOpen;
  }

  // adjustSiblingMargin() {
  //   const absoluteDiv = document.getElementById('navbar');
  //   const siblingDiv = document.getElementById('open-close-container');
  //   console.log(absoluteDiv.clientHeight + 11.77);
  //   const absoluteDivHeight = absoluteDiv.offsetHeight + 11.77;
  //   siblingDiv.style.marginTop = absoluteDivHeight + 'px';
  // }
}
